interface IAppDownloadButton {
  href: string;
  icon: React.ReactNode;
  label: string;
  appName: string;
}

const AppDownloadButton = ({
  href,
  icon,
  label,
  appName,
}: IAppDownloadButton) => {
  // rendering app download button component here
  return (
    <a
      href={href}
      className='w-[180px] flex items-center justify-center gap-2 bg-legal-brown text-legal-dark-gray px-4 py-3 rounded-md hover:opacity-70 duration-300'
    >
      <div>{icon}</div>

      <div className='font-marcellus capitalize'>
        <p className='text-xs md:text-sm leading-[1]'>{label}</p>
        <p className='text-lg font-bold leading-[1]'>{appName}</p>
      </div>
    </a>
  );
};

export default AppDownloadButton;
